import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Loader from '../components/Loader';
import { useEmbedding } from '../context/embedContext';
import { PdsClientEventName, PdsVendorEventName } from '../../shared';
import { AppStoreContext } from '../context/appStoreContext';
import { embedAuthenticate } from '../utils/services/authAPI';
import { parentWindow } from '../utils/embedHelper';

const notifyVendorPostAuthentication = () => {
  const authenticationSuccessEvent = {
    type: PdsClientEventName.CLIENT_AUTHENTICATION_SUCCESS,
    data: {},
  };
  parentWindow.postMessage(authenticationSuccessEvent, '*');
  const configurationFinishedEvent = {
    type: PdsClientEventName.CLIENT_CONFIGURATION_FINISHED,
    data: {},
  };
  parentWindow.postMessage(configurationFinishedEvent, '*');
};

const EmbedPage = React.memo(() => {
  const { setEmbedState } = useEmbedding();
  const { reAuthenticate, setReAuthenticate } = useContext(AppStoreContext);
  const history = useHistory();
  const initState = async event => {
    if (event.source === parentWindow && event.data.type === PdsVendorEventName.VENDOR_INIT) {
      const initialRoute = '/';
      // Check for either useSso or ssoAuthenticated
      if (event.data.data.useSso || event.data.data.ssoAuthenticated) {
        setEmbedState({
          isEmbedded: true,
          sdkVersion: event.data.data.sdkVersion,
          interactiveDesignId: event.data.data.interactiveDesignId,
          hideDesignSidebar: !!event.data.data.hideDesignSidebar,
          hidePreviewButton: !!event.data.data.hidePreviewButton,
          hideReadModeButton: !!event.data.data.hideReadModeButton,
          hideDesignTemplateName: !!event.data.data.hideDesignTemplateName,
        });
        history.push(`${initialRoute}interactiveDesign/${event.data.data.interactiveDesignId}`);
        notifyVendorPostAuthentication();
      } else {
        if (event?.data?.data?.token) {
          try {
            const response = await embedAuthenticate(event.data.data.token);
            if (response?.status === 'OK') {
              setEmbedState({
                isEmbedded: true,
                sdkVersion: event.data.data.sdkVersion,
                interactiveDesignId: event.data.data.interactiveDesignId,
                hideDesignSidebar: !!event.data.data.hideDesignSidebar,
                hidePreviewButton: !!event.data.data.hidePreviewButton,
                hideReadModeButton: !!event.data.data.hideReadModeButton,
                hideDesignTemplateName: !!event.data.data.hideDesignTemplateName,
              });
              history.push(
                `${initialRoute}interactiveDesign/${event.data.data.interactiveDesignId}`,
              );
              notifyVendorPostAuthentication();
            } else if (response?.status !== 'OK') {
              const errorEvent = {
                type: PdsClientEventName.CLIENT_AUTHENTICATION_FAILED,
                data: {},
              };
              parentWindow.postMessage(errorEvent, '*');
              setReAuthenticate(true);
            }
          } catch (error) {
            const errorEvent = {
              type: PdsClientEventName.CLIENT_AUTHENTICATION_FAILED,
              data: error,
            };
            parentWindow.postMessage(errorEvent, '*');
          }
        } else {
          console.error('Token sent via the sdk is empty');
        }
      }
    }
  };

  useEffect(() => {
    const event = {
      type: PdsClientEventName.CLIENT_INIT,
      data: {},
    };
    parentWindow.postMessage(event, '*');
    window.addEventListener('message', initState);
    return () => {
      window.removeEventListener('message', initState);
    };
  }, []);

  return <>{!reAuthenticate && <Loader fullpage={true} />}</>;
});

EmbedPage.displayName = 'EmbedPage';
export { EmbedPage };
